import { render } from "./App.vue?vue&type=template&id=41c58f44"
const script = {}

import "./App.vue?vue&type=style&index=0&id=41c58f44&lang=less"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__